module.exports = __webpack_public_path__ + "static/assets/585d4be2a12ebfaf4356bbe9f0541ab6.svg";